import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./with-back-arrow.module.css"

@tagName("")
export default class DayMenuTitleWithBackArrow extends Component {
  readonly styles = styles
}
